import { z } from 'zod';
import { isoUtcDateTimeSchema } from '../date-time-schema';
import { itemCustomFieldValueSchema } from './custom-field-values-dto';
import { itemDependencySchema } from './dependency-dto';
import { estimationSchema } from './estimation-dto';
import { itemScheduleDatesSchema, schedulingTypeSchema } from './item-schedule-dto';

export const itemLegacySchema = z.object({
  id: z.number().int().positive(),
  name: z.string().optional(),
  priority: z.string(),
  timeSpentSeconds: z.number().int().optional(),
  schedulingType: schedulingTypeSchema.optional(),
  description: z.string().optional(),
  earliestStartDateTime: isoUtcDateTimeSchema.optional(),
  deadlineDateTime: isoUtcDateTimeSchema.optional(),
  plannedStartDateTime: isoUtcDateTimeSchema.optional(),
  plannedFinishDateTime: isoUtcDateTimeSchema.optional(),
  schedules: itemScheduleDatesSchema.optional(),
  doneDateTime: isoUtcDateTimeSchema.optional(),
  dependencies: z.array(itemDependencySchema),
  estimationSchema: estimationSchema.nullable().optional(),
  createdAt: isoUtcDateTimeSchema.optional(),
  updatedAt: isoUtcDateTimeSchema.optional(),
  createdBy: z.string(),
  updatedBy: z.string(),
  itemTypeId: z.number().int().positive(),
  itemStatusId: z.number().int().positive(),
  parentId: z.number().int().positive().optional(),
  teamId: z.number().int().positive().optional(),
  estimationId: z.number().int().positive().optional(),
  customFields: z.record(z.string(), itemCustomFieldValueSchema).optional(),
  externalKey: z.string().nullable().optional(),
  externalLink: z.string().nullable().optional(),
  externalCreatedAt: isoUtcDateTimeSchema.optional(),
  planId: z.number().int().positive().optional(),
});

export const itemBulkFetchItemLegacySchema = itemLegacySchema.partial().required({ id: true });
export const itemBulkFetchSystemFieldLegacySchema = itemBulkFetchItemLegacySchema
  .omit({ customFields: true })
  .keyof();

export const itemBulkFetchItemsByIdLegacySchema = z.record(
  z.string(),
  itemBulkFetchItemLegacySchema,
);

export const itemBulkFetchMetadataLegacySchema = z.object({
  missingItemIds: z.array(z.number().int().positive()),
  missingCustomFieldIds: z.array(z.number().int().positive()),
});

export const itemBulkFetchResponseLegacySchema = z.object({
  itemsById: itemBulkFetchItemsByIdLegacySchema,
  metadata: itemBulkFetchMetadataLegacySchema,
});

export type ItemLegacyDTO = z.infer<typeof itemLegacySchema>;
export type ItemBulkFetchItemLegacyDTO = z.infer<typeof itemBulkFetchItemLegacySchema>;
export type ItemBulkFetchSystemFieldLegacyDTO = z.infer<
  typeof itemBulkFetchSystemFieldLegacySchema
>;
export type ItemBulkFetchItemsByIdLegacyDTO = z.infer<typeof itemBulkFetchItemsByIdLegacySchema>;
export type ItemBulkFetchMetadataLegacyDTO = z.infer<typeof itemBulkFetchMetadataLegacySchema>;
export type ItemBulkFetchResponseLegacyDTO = z.infer<typeof itemBulkFetchResponseLegacySchema>;
